import { render, staticRenderFns } from "./DataSingleImageGallery.vue?vue&type=template&id=f4941858&"
import script from "./DataSingleImageGallery.vue?vue&type=script&lang=js&"
export * from "./DataSingleImageGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports